import { TripType } from '@honeycomb/data';
import { searchCreatedRoute } from './searchCreatedRouting';
import { router } from '../utils/router';
// Modify response from searchCreatedRoute to route to estab page
export function priceCalendarSearchCreatedRoute(searchParameters, estabId) {
    const route = searchCreatedRoute(searchParameters, true);
    const url = route[0].toString();
    const tripParams = url.split('?')[1];
    const tripType = searchParameters.tripType === TripType.Hotel ? '/hotels/' : '/holidays/hotels/';
    const newUrl = `${tripType}${estabId}?${tripParams}`;
    return [newUrl, route[1], { scroll: false }];
}
export function priceCalendarSearchCreatedRouting(estabId) {
    return (params) => {
        if (params) {
            router.push(params, () => priceCalendarSearchCreatedRoute(params, estabId));
        }
    };
}
